import React from 'react';
import { observer } from 'mobx-react';
import { message } from 'antd';
import { WeaBrowser, WeaTools, WeaLocaleProvider, WeaInputEncrypt } from 'ecCom';
import { spellResourceCondition } from '../../../components/excel-layout/cell-field/browser-element/Browser';
import { toJS } from 'mobx';
const getLabel = WeaLocaleProvider.getLabel;
interface Props {
  editable?: boolean;
  value?: string;
  valueSpan?: string;
  onChange: any;
  column?;
  row?;
  replaceDatas?;
  defalutSeclevel?;
}

@observer
export default class Browser extends React.Component<Props, any> {
  constructor(props) {
    super(props);
    this.state = { replaceDatas: undefined };
  }

  render() {
    const { column, row, defalutSeclevel } = this.props;
    let hide = column && column.isHide && column.isHide(row);
    let replaceDatas = toJS(column.browserConditionParam.replaceDatas);
    let replaceDatas1: any = [];
    let names: any;
    const browserProps = column.browserConditionParam || {};
    let tempBrowserProps = {
      dataParams:browserProps.dataParams,
      conditionDataParams:browserProps.conditionDataParams,
      completeParams:browserProps.completeParams,
    }
    if (this.props.editable) {
      let ids = row.$(column.key).values().split(',');
      let names = row.$(column.key + 'span').values() ? JSON.parse(row.$(column.key + 'span').values()) : '';
      ids.forEach((element, index) => {
        if (element != '') replaceDatas.push({ id: element, name: names[index] });
      });
      if(column.fieldtype == '141'){
        if(row.$(column.key + 'span').values()){
          let spanvalue = JSON.parse(row.$(column.key + 'span').values());
          spanvalue.forEach((element)=>{
            if(element != null && element.prop ){
              replaceDatas1 = replaceDatas1.concat(element.prop);
            }
          });
        }
      }
      const bind = toJS(row.$(column.key).bind()) || {};
      const bindBrowsers = bind.browserProps;
      let secretLevel = defalutSeclevel || 4;
      
      if(row.has("seclevel")){
        secretLevel = row.$('seclevel').values();
      }
     

      tempBrowserProps = {
        dataParams:{...tempBrowserProps.dataParams,...bindBrowsers.dataParams,"secretLevel":secretLevel},
        conditionDataParams:{...tempBrowserProps.conditionDataParams,...bindBrowsers.conditionDataParams},
        completeParams:{...tempBrowserProps.completeParams,...bindBrowsers.completeParams,"secretLevel":secretLevel},
      }
      // dataParams = { ...dataParams, ...bind.dataParams };
      // conditionDataParams = { ...conditionDataParams, ...bind.conditionDataParams };
      // completeParams = { ...completeParams, ...bind.completeParams };
    } else {
      names = row.$(column.key + 'span').values();
    }

    if (column.fieldtype == '34') {//请假类型浏览框单独处理，设置value
      return (
        <div style={hide ? { display: 'none' } : { display: 'block' }}>
          {this.props.editable ?
            <WeaBrowser ecId={`${this && this.props && this.props.ecId || ''}_WeaBrowser@q06omy`}
              {...browserProps}
              {...tempBrowserProps}
              //replaceDatas={this.state.replaceDatas || replaceDatas}
              value={replaceDatas[0] && replaceDatas[0].id}
              onChange={(ids, names, datas) => {
                //this.setState({replaceDatas: datas});
                this.props.onChange(ids, names, datas);
                if (column && column.onChange) {
                  column.onChange(ids, row, names, datas);
                }
              }} /> : <span dangerouslySetInnerHTML={{ __html: names }}></span>}
        </div>
      )
    }else if(column.fieldtype == '141'){
      return (
      <div style={hide ? { display: 'none' } : { display: 'block' }}>
          {this.props.editable ?
            <WeaBrowser ecId={`${this && this.props && this.props.ecId || ''}_WeaBrowser@0lbme4`}
              {...browserProps}
              {...tempBrowserProps}
              replaceDatas={this.state.replaceDatas || replaceDatas1}
              onChange={(ids, names, datas) => {
                this.setState({ replaceDatas: datas });
                let id = spellResourceCondition(datas);
                this.props.onChange(id, names, datas);
                if (column && column.onChange) {
                  column.onChange(id, row, names, datas);
                }
              }} /> : <span dangerouslySetInnerHTML={{ __html: names }}></span>}
        </div>
      )
    } else {
      const { desensitization} = WeaTools.EncryBase;
      let dataalign = column.dataalign == undefined ? "" : column.dataalign;
      let bindObj = row.$(column.key).bind();
      return (
        <div style={hide ? { display: 'none' } : { display: 'block' }}>
          {this.props.editable ?
            <WeaBrowser ecId={`${this && this.props && this.props.ecId || ''}_WeaBrowser@ijkhnj`}
              {...browserProps}
              {...tempBrowserProps}
              replaceDatas={bindObj.value&&this.state.replaceDatas || replaceDatas}
              onChange={(ids, names, datas) => {
                this.setState({ replaceDatas: datas });
                this.props.onChange(ids, names, datas);
                if (column && column.onChange) {
                  column.onChange(ids, row, names, datas);
                }
              }}
              onBeforeFocusCheck={(success)=>{
                if (row.value.hasOwnProperty('seclevel')) { // 存在密级字段才进行必填提醒
                    const { value } = row.$('seclevel').bind();
                    if (value) {
                        success();
                    } else {
                        message.error(getLabel('530630','请先填写卡片密级！'));
                    }
                } else {
                    success();
                }
            }}
            /> : desensitization(names)? <WeaInputEncrypt ecId={`${this && this.props && this.props.ecId || ''}_WeaInputEncrypt@9cliz8`}
              type="TEXTAREA"
              className="wea-url"
              style={{ textAlign: dataalign }}
              value={names}
            />   : <span dangerouslySetInnerHTML={{ __html: names }}></span>}
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/mobx-table/table-cell/Browser.tsx